export const INGREDIENT_CATEGORIES_ICONS_A = {
    "61ba5febf650b910650f1a39": "verduras.png",
    "61ba5febf650b910650f1a3a": "frutas.png",
    "61ba5febf650b910650f1a3b": "cereales con grasa.png",
    "61ba5febf650b910650f1a3c": "cereales sin grasa.png",
    "61ba5febf650b910650f1a3d": "leguminosas.png",
    "61ba5febf650b910650f1a3e": "alimentos de origen animal.png",
    "61ba5febf650b910650f1a3f": "alimentos de origen animal.png",
    "61ba5febf650b910650f1a40": "alimentos de origen animal.png",
    "61ba5febf650b910650f1a41": "alimentos de origen animal.png",
    "61ba5febf650b910650f1a42": "leche descremada.png",
    "61ba5febf650b910650f1a43": "leche semidescremada.png",
    "61ba5febf650b910650f1a44": "leche entera.png",
    "61ba5febf650b910650f1a45": "leche con azucar.png",
    "61ba5febf650b910650f1a46": "aceites y grasas.png",
    "61ba5febf650b910650f1a47": "aceites y grasas con proteinas.png",
    "61ba5febf650b910650f1a48": "azucares sin grasa.png",
    "61ba5febf650b910650f1a49": "azucares con grasa.png",
    "61ba5febf650b910650f1a4a": "alimentos libres en energia.png",
    "61ba5febf650b910650f1a4b": "bebidas alcoholicas.png",
  };
  
  export const INGREDIENT_CATEGORIES_ICONS_B = {
    "61ba5febf650b910650f1a39": "verduras 2.png",
    "61ba5febf650b910650f1a3a": "frutas 2.png",
    "61ba5febf650b910650f1a3b": "cereales con grasa 2.png",
    "61ba5febf650b910650f1a3c": "cereales sin grasa 2.png",
    "61ba5febf650b910650f1a3d": "leguminosas 2.png",
    "61ba5febf650b910650f1a3e": "alimentos de origen animal 2.png",
    "61ba5febf650b910650f1a3f": "alimentos de origen animal 2.png",
    "61ba5febf650b910650f1a40": "alimentos de origen animal 2.png",
    "61ba5febf650b910650f1a41": "alimentos de origen animal 2.png",
    "61ba5febf650b910650f1a42": "leche descremada.png",
    "61ba5febf650b910650f1a43": "leche semidescremada.png",
    "61ba5febf650b910650f1a44": "leche entera.png",
    "61ba5febf650b910650f1a45": "leche con azucar 2.png",
    "61ba5febf650b910650f1a46": "aceites y grasas 2.png",
    "61ba5febf650b910650f1a47": "aceites y grasas con proteinas 2.png",
    "61ba5febf650b910650f1a48": "azucares sin grasa 2.png",
    "61ba5febf650b910650f1a49": "azucares con grasa 2.png",
    "61ba5febf650b910650f1a4a": "alimentos libres en energia 2.png",
    "61ba5febf650b910650f1a4b": "bebidas alcoholicas 2.png",
  };